import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { CREATE_DSR_REQUEST } from 'mocks/mutations';
import { logError } from 'commons/logger';
import scrollTo from 'commons/scrollTo';
import withApolloClient from 'components/hoc/withApolloClient';

export const withState = Component => {
  class DsrHOC extends React.Component {
    state = { errMsg: null, isSuccess: false, isLoading: false };

    createDSRRequest = async values => {
      try {
        this.setState({ errMsg: null, isSuccess: false, isLoading: true });

        const res = await this.props.client.mutate({
          mutation: CREATE_DSR_REQUEST,
          variables: {
            input: {
              request_email: values.email_address,
              request_first_name: values.first_name,
              request_last_name: values.last_name,
              request_phone: values.phone_number,
              request_address: values.address,
              request_city: values.city,
              request_state: values.state,
              request_zip_code: values.zipcode,
              request_type: values.request_type,
              additional_information: values.additional_information,
            },
          },
        });

        if (res.data && res.data.createDataSubmitRequest.success) {
          scrollTo({ left: 0, top: 0, behavior: 'smooth' });
          this.setState({ isSuccess: true, isLoading: false });
        } else {
          this.setState({
            isLoading: false,
            errMsg: get(
              res.data.createDataSubmitRequest,
              'errors.0.message',
              'Unable to save your request. Please try again.'
            ),
          });
        }
      } catch (e) {
        logError(e);
        this.setState({ errMsg: e.message, isLoading: false });
      }
    };

    render() {
      return (
        <Component
          state={{
            errMsg: this.state.errMsg,
            isLoading: this.state.isLoading,
            isSuccess: this.state.isSuccess,
          }}
          actions={{ createDSRRequest: this.createDSRRequest }}
        />
      );
    }
  }

  DsrHOC.propTypes = {
    client: PropTypes.shape({
      mutate: PropTypes.func,
    }),
  };

  return withApolloClient(DsrHOC);
};
